/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PropertyOutPoi
 */
export interface PropertyOutPoi {
    /**
     * 
     * @type {number}
     * @memberof PropertyOutPoi
     */
    poiId: number;
    /**
     * 
     * @type {number}
     * @memberof PropertyOutPoi
     */
    propertyId: number;
    /**
     * 
     * @type {Date}
     * @memberof PropertyOutPoi
     */
    modificationDate: Date;
}

export function PropertyOutPoiFromJSON(json: any): PropertyOutPoi {
    return PropertyOutPoiFromJSONTyped(json, false);
}

export function PropertyOutPoiFromJSONTyped(json: any, ignoreDiscriminator: boolean): PropertyOutPoi {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'poiId': json['poiId'],
        'propertyId': json['propertyId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function PropertyOutPoiToJSON(value?: PropertyOutPoi | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'poiId': value.poiId,
        'propertyId': value.propertyId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


